import * as apiv2 from '../apiv2';

const getTasksRequest = () => ({
  type: 'GET_TASKS_REQUEST'
});

const getTasksSuccess = data => ({
  type: 'GET_TASKS_SUCCESS',
  data
});

const getTasksFailure = error => ({
  type: 'GET_TASKS_FAILURE',
  error
});

const postTaskRequest = () => ({
  type: 'POST_TASK_REQUEST'
});

const postTaskSuccess = data => ({
  type: 'POST_TASK_SUCCESS',
  data
});

const postTaskFailure = error => ({
  type: 'POST_TASK_FAILURE',
  error
});

export function createTask(
  task
) {
  return (dispatch, getState) => {
    const { informedWebApp } = getState();
    dispatch(postTaskRequest());
    return apiv2.createTask(informedWebApp, task)
      .then(result => {
        dispatch(postTaskSuccess(result));
        dispatch(getTaskList());
      })
      .catch(error => dispatch(postTaskFailure(error)));;
  };
}

export function updateTask(
  task
) {
  return (dispatch, getState) => {
    const { informedWebApp } = getState();
    dispatch(postTaskRequest());
    return apiv2.updateTask(informedWebApp, task)
      .then(result => {
        dispatch(postTaskSuccess(result));
        dispatch(getTaskList());
      })
      .catch(error => dispatch(postTaskFailure(error)));;
  };
}

export function getTaskList() {
  return (dispatch, getState) => {
    const { informedWebApp } = getState();

    dispatch(getTasksRequest());
    return apiv2.getTaskList(informedWebApp)
      .then(result => {
        dispatch(getTasksSuccess(result));
      })
      .catch(error => dispatch(getTasksFailure(error)));
  };
}


// WEBPACK FOOTER //
// ./src/actions/tasks.js